<div class="comparative-analysis-page">
  <div class="top-action-section">
    <div class="filter-container">
      <div class="filter">
        <label class="filter-label">Tickers</label>
        <div class="ticker-search-filter">
          <app-ticker-search
            [tickers]="tickers"
            [onScreen]="true"
            [isComp]="true"
            [hasSearchIcon]="true"
            [disabled]="
              !tickerModalDataReady ||
              isMetaInProgress ||
              isUserSettingUpdateInProgress
            "
            [suggestedTickers]="suggestedPeers"
            placeholder="&nbsp;Add Tickers"
            [maxSelectedTickerCount]="tickerLimit"
            (onSearchedTickerUpdate)="onSearchTickerSelection($event)"
          ></app-ticker-search>

          <button
            nz-button
            class="on-screen-search__edit-btn"
            (click)="editTickers()"
            [disabled]="
              !tickerModalDataReady ||
              isMetaInProgress ||
              isUserSettingUpdateInProgress
            "
          >
            Edit
          </button>
        </div>
      </div>
      <div class="filter currency-alignment">
        <va-currency-select
          size="small"
          selectWidth="78"
          labelPlacement="top"
          [bottomBorderView]="true"
          [selectedCurrency]="currency"
          [apiEP]="apiEP"
          apiUrl="/api/get_available_currencies"
          (onChange)="handleCurrencyChange($event)"
          [disabled]="isUserSettingUpdateInProgress || !isMetaReady"
        ></va-currency-select>
      </div>
      <div class="filter price-perf-alignment">
        <app-single-select-dropdown
          *ngIf="pricePerformanceAvailable"
          label="Price performance period"
          width="150px"
          [items]="pricePerformanceOptions"
          [selectedItem]="pricePerformance || undefined"
          (callback)="handlePricePerformanceChange($event)"
          [disabled]="isUserSettingUpdateInProgress || !isMetaReady"
        >
        </app-single-select-dropdown>
      </div>
    </div>
    <div class="cta-right-section">
      <va-button
        btnType="outline"
        size="medium"
        (onClick)="hanldeColumnPickerClick()"
        title="Column Picker"
        [isDisabled]="isUserSettingUpdateInProgress || !isMetaReady"
        class="mr-12"
        >Column Picker</va-button
      >
      <app-export-to-excel-dropdown
        class="export-button"
        [(isPopoverVisible)]="isExportPopoverVisible"
        [disabled]="isUserSettingUpdateInProgress || !isMetaReady"
        [optionList]="excelToExportDropdownOptions"
        [isExportInProgress]="isExportInProgress"
        (onListItemClick)="handleETEListItemClick($event)"
      ></app-export-to-excel-dropdown>
    </div>
  </div>
  <div class="second-action-section display-flex flex-align-center">
    <div *ngIf="isActive" class="comparative-formula-bar">
      <app-subheader-formulabar
        [comparativeAnalysisBorderedFormulaBar]="true"
      ></app-subheader-formulabar>
    </div>
  </div>

  <div *ngIf="!isMetaReady" style="height: 600px">
    <div nz-menu>
      <div
        *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6]"
        style="padding: 0px 15px 0px 15px"
      >
        <nz-skeleton
          [nzTitle]="true"
          [nzActive]="true"
          [nzParagraph]="false"
        ></nz-skeleton>
      </div>
    </div>
  </div>
  <section *ngIf="isMetaReady" class="comparative-grid-content-section">
    <app-tpr-peers-grid-wrapper
      [meta]="meta"
      [isMetaInProgress]="!isMetaReady"
      [isTabVisible]="isActive"
      gridContainerClassName=""
      showGridPagination="true"
      (updateTickerOrder)="updateTickerOrder($event)"
    ></app-tpr-peers-grid-wrapper>
    <div class="factset-message">
      {{ factsetCopyRightMessage }}
    </div>
  </section>
</div>

<app-column-picker-modal
  [data]="columnPickerData"
  [isModalVisible]="isColumnPickerModalVisible"
  (onApply)="hanldeColumnPickerApplyClick($event)"
  (onReset)="handleColumnPickerResetClick()"
  (onCancel)="handleColumnPickerCancelClick()"
  (onDrag)="handleColumnDrag($event)"
></app-column-picker-modal>

<!-- Snackbar -->
<ng-template #successTemplate>
  <div class="snackbar-content">
    <va-icon
      isFontAwesome="true"
      [name]="faCheck"
      class="snack-icon snack-success-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #failureTemplate>
  <div class="snackbar-content">
    <va-icon
      isFontAwesome="true"
      [name]="faTimesCircle"
      class="snack-icon snack-failure-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #infoTemplate>
  <div class="snackbar-content">
    <va-icon
      isFontAwesome="true"
      [name]="faInfoCircle"
      class="snack-icon snack-info-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
    </span>
  </div>
</ng-template>
